// src/composables/useProfileFieldCheck.js
import { useStore } from "vuex";

export function useProfileFieldShow(tenantConfig) {
  const showProfileField = (fieldName) => {
    return (
      tenantConfig.value?.profileFieldsExtraShow?.includes(fieldName) || false
    );
  };

  return {
    showProfileField,
  };
}

export function useProfileFieldHide(tenantConfig) {
  const showProfileField = (fieldName) => {
    return (
      tenantConfig.value?.profileFieldsExtraHide?.includes(fieldName) || false
    );
  };

  return {
    showProfileField,
  };
}

export function useProfileFieldRequired(tenantConfig) {
  const profileFieldRequired = (fieldName) => {
    return (
      tenantConfig.value?.requiredProfileFields?.includes(fieldName) || false
    );
  };

  return {
    profileFieldRequired,
  };
}

export function useRequiredOnboardingSection(tenantConfig) {
  const requiredOnboardSection = (section) => {
    return tenantConfig.value?.requiredOnboardSteps?.includes(section) || false;
  };

  return {
    requiredOnboardSection,
  };
}

export function useAllowDuplicatedCustomerNumber(tenantConfig) {
  const allowDuplicatedCustomerNumber = () => {
    return tenantConfig.value?.allowDuplicatedCustomerNumber || false;
  };

  return {
    allowDuplicatedCustomerNumber,
  };
}

export function useAllowOnboard(tenantConfig) {
  const allowOnboard = () => {
    return tenantConfig.value?.allowOnboard || false;
  };

  return {
    allowOnboard,
  };
}

export function setLinkInWelcomeBox(tenantConfig) {
  const welcomeBoxLink = (user) => {
    const isStaffRole =
      user?.roles?.some((role) => role.name === "staff") ?? false;

    if (isStaffRole && tenantConfig.value?.linkInWelcomeBoxStaff) {
      return tenantConfig.value.linkInWelcomeBoxStaff;
    }

    return tenantConfig.value?.linkInWelcomeBox || "stammdaten";
  };

  const shouldShowProfileLink = (user) => {
    const isWholesaler =
      user?.roles?.some((role) => role.name === "wholesaler") ?? false;
    const isStaffRole =
      user?.roles?.some((role) => role.name === "staff") ?? false;

    if (isWholesaler) {
      return false;
    }

    if (isStaffRole) {
      return Boolean(tenantConfig.value?.linkInWelcomeBoxStaff);
    }

    return true;
  };

  return {
    welcomeBoxLink,
    shouldShowProfileLink,
  };
}

export function useIndirectCanAddCustomerNumber(tenantConfig) {
  const indirectCanSeeCustomerNumberForm = () => {
    return tenantConfig.value?.indirectCanSeeCustomerNumberForm || false;
  };

  return {
    indirectCanSeeCustomerNumberForm,
  };
}

export function userCanSeeTextOverPointBox(tenantConfig) {
  const seeTextOverPointBox = () => {
    return tenantConfig.value?.textOverPoints || false;
  };

  return {
    seeTextOverPointBox,
  };
}

export function userCanSeeRedSlashInPointsOverview(tenantConfig) {
  const seeRedSlashInPointsOverview = () => {
    return tenantConfig.value?.showRedSlashPointOverview;
  };

  return {
    seeRedSlashInPointsOverview,
  };
}

export function userCanSeeKickbackInfo(tenantConfig) {
  void tenantConfig;
  const store = useStore();

  const showKickbackFeeInfo = () => {
    return store.getters.getTenantPermissions?.includes("kickbackInfo");
  };

  return {
    showKickbackFeeInfo,
  };
}

export function userCanSeeKickbackList(tenantConfig) {
  void tenantConfig;
  const store = useStore();

  const showKickbackFeeList = () => {
    return store.getters.getTenantPermissions?.includes("kickback_list");
  };

  return {
    showKickbackFeeList,
  };
}

export function userCanSeeIbanInfo(tenantConfig) {
  const showIbanInfo = () => {
    return tenantConfig.value?.showIbanInfo;
  };

  return {
    showIbanInfo,
  };
}

export function userCanSeeCurrentMonthPointsInfo(tenantConfig) {
  const showCurrentMonthPointsInfo = () => {
    return tenantConfig.value?.showCurrentMonthPointsInfo;
  };

  return {
    showCurrentMonthPointsInfo,
  };
}

export function userCanSeeLastMonthPointsInfo(tenantConfig) {
  const showLastMonthPointsInfo = () => {
    return tenantConfig.value?.showLastMonthPointsInfo;
  };

  return {
    showLastMonthPointsInfo,
  };
}

export function userCanAddTenantEmails(tenantConfig) {
  const showTenantEmails = () => {
    return tenantConfig.value?.canSeeTenantEmails;
  };

  return {
    showTenantEmails,
  };
}

export function setOnlineTrainingLink(tenantConfig) {
  const onlineTrainingLink = () => {
    return tenantConfig.value?.linkForOnlineTrainings;
  };

  return {
    onlineTrainingLink,
  };
}

export function showExtendedOnlineTrainings(tenantConfig) {
  const extendedOnlineTrainigs = () => {
    return tenantConfig.value?.extendedOnlineTrainigs;
  };

  return {
    extendedOnlineTrainigs,
  };
}

export function getShowWelcomePointsInfo(tenantConfig) {
  const showWelcomePointsInfo = () => {
    return tenantConfig.value?.showWelcomePointsInfo || false;
  };

  return {
    showWelcomePointsInfo,
  };
}

export function getProfileVersion(tenantConfig) {
  const showProfileVersion = () => {
    return tenantConfig.value?.profileVersion || "Lite";
  };

  return {
    showProfileVersion,
  };
}

export function getShowServiceNumberPage(tenantConfig) {
  const showServiceNumberPage = () => {
    return tenantConfig.value?.showServiceNumberPage || false;
  };

  return {
    showServiceNumberPage,
  };
}

export function getShowStrategicPartners(tenantConfig) {
  const showStrategicPartners = () => {
    return tenantConfig.value?.showStrategicPartners || false;
  };

  return {
    showStrategicPartners,
  };
}

export function getShowTouchIncentive(tenantConfig) {
  const showTouchIncentive = () => {
    return tenantConfig.value?.showTouchIncentive || false;
  };

  return {
    showTouchIncentive,
  };
}

export function getShowBridgestoneContact(tenantConfig) {
  const showBridgestoneContact = () => {
    return tenantConfig.value?.showBridgestoneContact || false;
  };

  return {
    showBridgestoneContact,
  };
}

export function getShowPremiumPartnerContact(tenantConfig) {
  const showPremiumPartnerContact = () => {
    return tenantConfig.value?.showPremiumPartnerContact || false;
  };

  return {
    showPremiumPartnerContact,
  };
}

export function getHelpLink(tenantConfig) {
  const showHelpLink = () => {
    return tenantConfig.value?.menuQuestionMarkLink;
  };

  return {
    showHelpLink,
  };
}

export function userCanSeeRedSlashInInbox(tenantConfig) {
  const showRedSlashInbox = () => {
    return tenantConfig.value?.showRedSlashInbox;
  };

  return {
    showRedSlashInbox,
  };
}

export function userCanAddNewCustomerNumber(tenantConfig) {
  const canAddNewCustomerNumber = () => {
    return tenantConfig.value?.canAddNewCustomerNumber;
  };

  return {
    canAddNewCustomerNumber,
  };
}

export function userCanAddUpdateCustomerNumbers(tenantConfig) {
  void tenantConfig;
  const store = useStore();

  const canAddUpdateCustomerNumbers = () => {
    return store.getters.isModuleConfigEnabled(
      "users",
      "canAddUpdateCustomerNumbers",
    );
  };

  return {
    canAddUpdateCustomerNumbers,
  };
}

export function userShowCurrentMonthPointsSpendings(tenantConfig) {
  const showCurrentMonthPointsSpendings = () => {
    return tenantConfig.value?.showCurrentMonthPointsSpendings;
  };

  return {
    showCurrentMonthPointsSpendings,
  };
}
